import TemplateView from "../../TemplateView"
import GroupBySelector from "./GroupBySelector"
import UsersList from "./usersList/UsersList"
import UsersSelector from "./UsersSelector"
import GroupType from "../../enums/GroupType"
import UserWithAccessRights from "../../store/UserWithAccessRights"
import messageResource from "../../messageResource"
import {userHasAssignments} from "./utils"
import SimpleTooltip from '../../SimpleTooltip'
import $ from 'jquery'
import {userComparator} from '../../usersSelector/user_group_selector_util'

export default class AssignedUsersEditor extends TemplateView {
    constructor({
        onUserDelete = userData => {},
        onAssignedUsersChange = ({addedUserIds, removedUserIds}) => {},
        titleMessageKey = "",
        userSubtitleGenerator = user => "",
        managersMessageKey = null,
        addUsersMessageKey = "",
        emptyListMessageKey = "",
        canEditManagers = true,
        showPermissionIcons = false,
        usersSelectorTitle = "",
        renderUserSelectorToContent = false,
        refreshScrollCb = () => {},
        checkIfCanModify = user => true,
        getListDisabledTooltipText = user => '',
        getSelectorDisabledTooltipText = user => '',
    }) {
        super();

        this.params = {
            addUsersMessageKey,
            emptyListMessageKey,
            showPermissionIcons,
            renderUserSelectorToContent,
            onAssignedUsersChange,
            refreshScrollCb,
            getListDisabledTooltipText,
            getSelectorDisabledTooltipText,
            checkIfCanModify,
        }

        this.state = {
            groupBy: GroupType.USER_GROUP,
            userGroupsEnabled: true,
            timeZoneGroupsEnabled: true,
            users: [],
            userGroups: [],
            timeZoneGroups: [],
            canModifyAny: false,
            isBTYEnabled: false,
            isURAEnabled: false,
            isTTAEnabled: false,
            hideAssignButton: false,
        };

        this.onStateChanged(state => {
            let groupBy = null;
            if (state.userGroupsEnabled && state.timeZoneGroupsEnabled) {
                groupBy = state.groupBy;
            } else if (state.userGroupsEnabled) {
                groupBy = GroupType.USER_GROUP;
            } else if (state.timeZoneGroupsEnabled) {
                groupBy = GroupType.TIME_ZONE_GROUP;
            }

            const assignedUsers = state.users.filter(userHasAssignments);
            const activeAssignedUsers = assignedUsers.filter(user => user.active);
            const usersInList = canEditManagers ? activeAssignedUsers : activeAssignedUsers.filter(user => !user.hasManageAssignment);
            this.usersList.setState({
                users: usersInList,
                userGroups: state.userGroups,
                timeZoneGroups: state.timeZoneGroups,
                canModifyAny: state.canModifyAny,
                groupBy,
                isBTYEnabled: state.isBTYEnabled,
                isURAEnabled: state.isURAEnabled,
                isTTAEnabled: state.isTTAEnabled,
            });

            this.groupBySelector.setState({
                groupBy
            });

            if (state.canModifyAny) {
                const visibleInSelectorUsers = state.users.filter(user => user.assignedToViewer)
                const visibleAssignedUsers = _.intersection(assignedUsers, visibleInSelectorUsers)
                this.usersSelector.setState({
                    selection: visibleAssignedUsers.map(user => user.id),
                    users: visibleInSelectorUsers.map(user => {
                        const userWithAccessRights = UserWithAccessRights.fromRPC(user);
                        Object.assign(userWithAccessRights, user);
                        userWithAccessRights.canBeModified = this.params.checkIfCanModify(user)
                        return userWithAccessRights;
                    }).sort(userComparator),
                    userGroups: state.userGroups,
                    timeZoneGroups: state.timeZoneGroups,
                    userGroupsEnabled: state.userGroupsEnabled,
                    timeZoneGroupsEnabled: state.timeZoneGroupsEnabled,
                    groupBy,
                    title: usersSelectorTitle,
                    isBTYEnabled: state.isBTYEnabled,
                    isURAEnabled: state.isURAEnabled,
                    isTTAEnabled: state.isTTAEnabled,
                });
            }

            this.$title.text(messageResource.getMessage(titleMessageKey, [activeAssignedUsers.length]));

            if (managersMessageKey) {
                const activeAssignedManagersCount = activeAssignedUsers.filter(user => user.hasManageAssignment).length;
                if (activeAssignedManagersCount > 0) {
                    const managersMessage = messageResource.getMessage(managersMessageKey, [activeAssignedManagersCount]);
                    this.$otherUsersMessage.text(managersMessage);
                    this.$otherUsersMessage.show();
                } else {
                    this.$otherUsersMessage.hide();
                }
            } else {
                this.$otherUsersMessage.hide();
            }

            this.$el.toggleClass("emptyList", usersInList.length === 0 && state.canModifyAny);
            this.$el.toggleClass("hideGroupBySelector", !state.userGroupsEnabled || !state.timeZoneGroupsEnabled);
            this.$el.toggleClass('hideAssignUsersButton', state.hideAssignButton)
            this.$assignUsersButton.toggleClass("disabled", !state.canModifyAny);

            this.tooltip.setEnabled(!state.canModifyAny && !state.hideAssignButton)
        });

        this.usersList = new UsersList({
            onUserDelete: (userId) => {
                const userData = this.state.users.find(user => user.id === userId)
                onUserDelete(userData)
            },
            userSubtitleGenerator: userSubtitleGenerator,
            showPermissionIcons: this.params.showPermissionIcons,
            getDisabledTooltipText: this.params.getListDisabledTooltipText,
            canModifyPredicate: user => user.canBeModified && this.params.checkIfCanModify(user),
        })

        this.groupBySelector = new GroupBySelector({
            onGroupBySelected: groupBy => {
                this.setState({groupBy})
                this.params.refreshScrollCb()
            }
        });
    }

    templateHtml() {
        return "<div class='assignedUsersEditor'>" +
               "  <div class='header'>" +
               "    <div class='toolbox'>" +
               "      <div class='groupBySelectorContainer'>" +
               "        <div class='groupBySelectorLabel'><%=groupByLabel%></div>" +
               "      </div>" +
               "      <div class='separator'></div>" +
               "      <div class='assignUserButton components_button withPlusIcon'><%=assignUsersLabel%></div>" +
               "    </div>" +
               "    <div class='title'></div>" +
               "  </div>" +
               "  <div class='content'>" +
               "    <div class='usersListContainer'></div>" +
               "    <div class='otherUsersMessage'></div>" +
               "    <div class='emptyListMessage'><%-emptyListLabel%></div>" +
               "    <div class='emptyListArrow'></div>" +
               "  </div>" +
               "</div>"
    }

    afterRender() {
        this.$title = this.find(".title");
        this.$otherUsersMessage = this.find(".otherUsersMessage");

        this.usersList.init(this.find(".usersListContainer"));
        this.groupBySelector.init(this.find(".groupBySelectorContainer"));

        this.$assignUsersButton = this.find(".assignUserButton");

        this.usersSelector = new UsersSelector({
            selectionCallback: this.params.onAssignedUsersChange,
            showPermissionIcons: this.params.showPermissionIcons,
            canDeselectUser: user => user.canBeModified,
            parentEl: this.params.renderUserSelectorToContent ? this.getEl()[0] : null,
            refreshScrollOnShowCb: this.params.renderUserSelectorToContent
                ? (height) => this.refreshScrollOnShow(height)
                : () => {},
            refreshScrollOnHideCb: this.params.renderUserSelectorToContent
                ? () => this.refreshScrollOnHide()
                : () => {},
            getDisabledTooltipText: this.params.getSelectorDisabledTooltipText,
        }).init()
        this.$assignUsersButton.click(() => this.state.canModifyAny && !this.state.hideAssignButton && this.usersSelector.showAt(this.$assignUsersButton, "tr-br"));

        this.tooltip = new SimpleTooltip({
            text: messageResource.getMessage('task.list.create_pop_up.disabled_button'),
        }).init($('body'))
        this.tooltip.subscribeToMouseEvents(this.$assignUsersButton);
    }

    messageKeys() {
        return {
            assignUsersLabel: this.params.addUsersMessageKey,
            groupByLabel: "assigned_users_editor.view_by"
        }
    }

    templateModel() {
        return {
            emptyListLabel: this.params.emptyListMessageKey ? messageResource.getMessage(this.params.emptyListMessageKey) : "",
        }
    }

    refreshScrollOnShow(menuBottom) {
        const top = this.$el.offset().top
        const height = this.$el.outerHeight()
        if (top + height < menuBottom) {
            this.$el.height(menuBottom - top)
            this.params.refreshScrollCb()
        }
    }

    refreshScrollOnHide() {
        this.$el.css('height', '')
        this.params.refreshScrollCb()
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/AssignedUsersEditor.js